import { render } from "./ReleasePage.vue?vue&type=template&id=7ad815fd"
import script from "./ReleasePage.vue?vue&type=script&lang=js"
export * from "./ReleasePage.vue?vue&type=script&lang=js"

import "./ReleasePage.vue?vue&type=style&index=0&id=7ad815fd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__